const TIME_OUT = 30000

let BASE_URL = process.env.VUE_APP_BASE_URL

if (process.env.VUE_APP_TITLE === 'development') {
  BASE_URL = ''
}

export { BASE_URL, TIME_OUT }
